import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import TaskDetailBottomUI from './TaskDetailBottomUI.js'

class TaskDetailBottomSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      selectedTab: 'comment',
      refreshComments: null,
      refreshTaskLogs: null
    }
    this.taskId = this.props.task.taskId // used to avoid multiple fetches in componentWillReceiveProps
    this.bottomDivRef = null
  }

  render() {
    return (
      <TaskDetailBottomUI
        context={this.props.context}
        messageList={this.state.messageList}
        projectUserMap={this.props.projectUserMap}
        projectUserList={this.props.projectUserList}
        project={this.props.project}
        task={this.props.task}
        //
        selectedTab={this.state.selectedTab}
        onCommentClick={this.onCommentClick}
        onChangeLogClick={this.onChangeLogClick}
        setBottomDivRef={this.setBottomDivRef}
        scrollToBottom={this.scrollToBottom}
        onRefreshComments={this.onRefreshComments}
        onRefreshTaskLogs={this.onRefreshTaskLogs}
        refreshComments={this.state.refreshComments}
        refreshTaskLogs={this.state.refreshTaskLogs}
        //
        onForceTaskListRefresh={this.props.onForceTaskListRefresh}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
    }
  }

  onCommentClick = () => {
    this.setState({selectedTab: 'comment'})
  }

  onChangeLogClick = () => {
    this.setState({selectedTab: 'changeLog'})
  }

  onRefreshComments = () => {
    this.setState({refreshComments: Date.now()})
  }

  onRefreshTaskLogs = () => {
    this.setState({refreshTaskLogs: Date.now()})
  }

  setBottomDivRef = element => {
    if (element) this.bottomDivRef = element;
    /*console.log('setBottomDivRef', element)*/
  }

  scrollToBottom = () => {
    console.log('scrollToBottom')
    this.bottomDivRef.scrollIntoView({ behavior: "smooth" })
  }

  getMessages(context) {
    let arr = [
      'c_comments',
      'c_change_log',
      'c_delete',
      'c_cancel',
      'c_none'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('c_tsk_dtl_bot', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default TaskDetailBottomSF
